import React, { Component } from "react";
import moment from "moment";
import "../../main.scss";
import "./constituenttile.scss";
import Header from "../../components/lib/header/header";
import { apiCall } from "../../utils/restclient";
import Loader from "../../components/lib/loader/loader";
import { PrimaryButton } from "@fluentui/react";
import {
  getUserFriendlyErrorMessage,
  DEFAULT,
} from "../../utils/errormessages";
import dsLogo from "../../components/images/donorsearch_logo_small.png";
import { checkVersion } from "../../utils/buildinfo";
import { Helmet } from "react-helmet";

class ConstituentTile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showRefreshMessage: false,
      showErrorMessage: false,
      errorMessage: "",
      donorUserFriendlyId: 0,
      loading: true,
      organizationName: "",
      donorId: "",
      hasAddress: false,
      loadingMessage: "Loading...",
      donorSearchProfileUrl: "",
      lastSuccessSyncDateTime: null,
      token: null,
    };
  }

  _displayDSLogo() {
    return <img src={dsLogo} alt={"logo"} className="ds-logo-constituent" />;
  }
  _getToken(callback = null) {
    let token = window.localStorage.getItem("jwt");
    if (token != null) {
      this.state.token = token;
      this._getDonorInfo();
      return;
    }
    let authUrl = "v1/auth";
    let SecretKey = window.location.href.split("?")[0].split("/")[
      window.location.href.split("?")[0].split("/").length - 1
    ];
    let params = new URLSearchParams(window.location.search);
    let OrganizationName = params.get("orgname");
    let authBody = { OrganizationName, SecretKey };
    apiCall(authUrl, "POST", null, JSON.stringify(authBody))
      .then((authResponse) => {
        this.state.token = authResponse.JwtAccessToken;
        window.localStorage.setItem(`jwt`, authResponse.JwtAccessToken);
        if (callback) {
          callback();
          return;
        }
        this._getDonorInfo();
      })
      .catch((error) => {
        if (error.ErrorCode) {
          console.error('Auth Error:', error);
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(
              error.UserFriendlyErrorCode
            ),
            showErrorMessage: true,
            loading: false,
          });
        } else {
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(DEFAULT),
            showErrorMessage: true,
            loading: false,
          });
        }
      });
  }
  _getDonorInfo() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    if (params.get("primaryId")) {
      let organizationName = params.get("orgname");
      let donorUserFriendlyId = params.get("primaryId");
      this.setState({
        donorUserFriendlyId,
        organizationName,
        loading: true,
      });
      let getDonorInfoUrl = `v1/donors/${donorUserFriendlyId}`;
      apiCall(getDonorInfoUrl, "GET", {
        Authorization: `Bearer ${this.state.token}`,
      })
        .then((donorResponse) => {
          this.setState({
            donorId: donorResponse.DonorId,
            hasAddress: donorResponse.HasAddress,
            donorSearchProfileUrl: donorResponse.DonorSearchProfileUrl,
            lastSuccessSyncDateTime: donorResponse.LastSuccessSyncDateTime,
            loading: false,
          });
        })
        .catch((error) => {
          if (error.ErrorCode) {
            if (error.ErrorCode === "Unauthorized") {
              this.state.token = null;
              window.localStorage.removeItem("jwt");
              this._getToken(() => {
                this._getDonorInfo();
              });
              return;
            }
            this.setState({
              errorMessage: getUserFriendlyErrorMessage(
                error.UserFriendlyErrorCode,
                null,
                donorUserFriendlyId
              ),
              showErrorMessage: true,
              loading: false,
            });
          } else {
            this.setState({
              errorMessage: getUserFriendlyErrorMessage(DEFAULT),
              showErrorMessage: true,
              loading: false,
            });
          }
        });
    } else {
      setTimeout(() => {
        this._getDonorInfo();
      }, 5000);
    }
  }
  _getErrorMessage = () => {
    if (this.state.showErrorMessage) {
      return (
        <label className="error-msg center-horizontal">
          {this.state.errorMessage}
        </label>
      );
    }
    return null;
  };
  _getUpdatePageMessage = () => {
    return (
      <div>
        <label className="update-msg center-vertical center-horizontal">
          Update Complete. Please refresh your browser to view new data.
        </label>
      </div>
    );
  };
  _updateConstituent = () => {
    this.setState({
      errorMessage: "",
      showErrorMessage: false,
      loadingMessage: "Updating. Please wait.",
      loading: true,
    });
    let updateDonorUrl = `v1/donors/${this.state.donorUserFriendlyId}/sync`;
    apiCall(updateDonorUrl, "POST", {
      Authorization: `Bearer ${this.state.token}`,
    })
      .then((updateResponse) => {
        this.setState({ showRefreshMessage: true });
      })
      .catch((error) => {
        if (error.ErrorCode) {
          if (error.ErrorCode === "Unauthorized") {
            this.state.token = null;
            window.localStorage.removeItem("jwt");
            this._getToken(() => {
              this._updateConstituent();
            });
            return;
          }
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(
              error.UserFriendlyErrorCode,
              null,
              this.state.donorUserFriendlyId
            ),
            showErrorMessage: true,
            loading: false,
          });
        } else {
          this.setState({
            errorMessage: getUserFriendlyErrorMessage(DEFAULT),
            showErrorMessage: true,
            loading: false,
          });
        }
      });
  };

  _viewConstituentProfile = () => {
    window.open(this.state.donorSearchProfileUrl, "_blank");
  };

  componentDidMount() {
    checkVersion().then((result) => {
      if (result) {
        if (caches) {
          caches.keys().then((names) => {
            for (const name of names) {
              caches.delete(name);
            }
            let link =
              window.location.href.split("constituenttile")[0] +
              `constituenttile/${result}` +
              window.location.href.split("constituenttile")[1];
            window.location.href = link;
          });
        }
      }
    });

    this._getToken();
  }
  render() {
    if (this.state.showRefreshMessage) {
      return (
        <body
          style={{
            height: 150,
            width: "100%",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          {this._getUpdatePageMessage()}
        </body>
      );
    }
    if (this.state.loading) {
      return (
        <body style={{ height: "100%", width: "100%", flex: 1 }}>
          <Loader message={this.state.loadingMessage} />
        </body>
      );
    }
    return (
      <body
        style={{
          display: "block",
          height: "100%",
          width: "99%",
          backgroundColor: "white",
          flex: 1,
          marginRight: "autp",
          marginLeft: "auto",
        }}
      >
        <Helmet>
          <meta http-equiv="cache-control" content="no-cache" />
          <meta http-equiv="expires" content="0" />
          <meta http-equiv="pragma" content="no-cache" />
        </Helmet>
        <div className="buttons-container center-vertical">
          <PrimaryButton
            text="Perform Update"
            className="main-button update-btn"
            styles={{
              label: { fontWeight: "normal" },
              root: { backgroundColor: "#41C2CC", borderColor: "#41C2CC" },
              rootHovered: {
                backgroundColor: "#41C2CC",
                borderColor: "#41C2CC",
              },
            }}
            onClick={() => this._updateConstituent()}
            disabled={!this.state.hasAddress}
          />

          <PrimaryButton
            text="View Profile"
            className="main-button profile-btn main-button-color"
            styles={{
              label: { fontWeight: "normal" },
              root: { backgroundColor: "#41C2CC", borderColor: "#41C2CC" },
              rootHovered: {
                backgroundColor: "#41C2CC",
                borderColor: "#41C2CC",
              },
            }}
            onClick={() => {
              this._viewConstituentProfile();
            }}
            disabled={this.state.donorSearchProfileUrl ? false : true}
          />
        </div>
        {this._getErrorMessage()}

        {this.state.lastSuccessSyncDateTime ? (
          <div
            className="date-container"
            style={{
              backgroundColor: "white",
              position: "fixed",
              width: "98%",
              bottom: 0,
            }}
          >
            <label className="date-label">
              Last Update:{" "}
              {moment(this.state.lastSuccessSyncDateTime).format("M/D/YYYY")}
            </label>
          </div>
        ) : null}
        <Header />
        {this._displayDSLogo()}
      </body>
    );
  }
}
export default ConstituentTile;
